import { render, staticRenderFns } from "./chat-message.vue?vue&type=template&id=05d1d87d&scoped=true&"
import script from "./chat-message.vue?vue&type=script&lang=js&"
export * from "./chat-message.vue?vue&type=script&lang=js&"
import style0 from "./chat-message.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./chat-message.vue?vue&type=style&index=1&id=05d1d87d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d1d87d",
  null
  
)

export default component.exports